import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as Rx from 'rxjs';



const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8',
 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});


@Injectable()
export class UpdateSalesIdService {
UpdatesalesIdUrl = '/superadmin/rest/mgmt/account/sc';
// salesModelCountUrl = '/superadmin/rest/mgmt/sc/commission/count?';
// salesConfigUrl = '/superadmin/rest/mgmt/sc/config';
// salesChannelCountUrl = '/superadmin/rest/mgmt/sc/count?';
// salesChannelUrl = '/superadmin/rest/mgmt/sc';
// salesRepCountUrl = '/superadmin/rest/mgmt/sc/rep/count?';
// salesRepUrl = '/superadmin/rest/mgmt/sc/rep';

    constructor(private http: HttpClient) { }
    updateSalesid(accId, salesChannelCode) {
        return this.http.put(this.UpdatesalesIdUrl + '/' + accId + '/' + salesChannelCode, { headers: headers});
      }

}
